import Mlp from 'umg-ember-backend/components/record-explorer/for/mlp';

<template><Mlp @records={{@model}} @recordType='mlp' /></template>
